import 'styles/cart/controls.scss';

import React from 'react';

import propTypes from 'propTypes';
import PropTypes from 'prop-types';
import QuantityInput from 'common/components/QuantityInput';

export default class CollectionPendingQuantityInput extends React.Component {
  static propTypes = {
    collection: PropTypes.shape({
      variants: PropTypes.array.isRequired,
      id: PropTypes.number.isRequired,
      name: PropTypes.string.isRequired,
      description: PropTypes.string.isRequired,
    }),
    quantityPending: propTypes.number.isRequired,
  };

  static defaultProps = {
    defaultQuantity: 0,
  };

  updateQuantity = quantity => {
    this.props.changeCollectionQuantity(this.props.collection, quantity);
  };

  render() {
    const value = this.props.quantityPending;
    return (
      <QuantityInput
        className="CollectionPendingQuantityInput"
        defaultQuantity={this.props.defaultQuantity}
        onChange={this.updateQuantity}
        value={value}
      />
    );
  }
}



// WEBPACK FOOTER //
// ./app/javascript/apps/cart/components/CollectionPendingQuantityInput.js